import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { Dialog, DialogTitle, Card, Toolbar, Typography, Grid, DialogActions, Button } from "@material-ui/core";
import TableGeneric from '../../compartidos/abms/TableGeneric';

const useStyles = makeStyles((theme) => ({
    root: {
        maxHeight: 500,
        marginTop: "auto",
        marginBottom: "auto"
    },
    rootTable: {
        padding: 25,
    },
    header: {
        background: '#68389F',
        color: 'white'
    },
    botonera: {
        marginTop: 25,
        marginLeft: 55,
        marginBottom: 20,
        paddingBottom: 13
    },
    formControl: {
        marginTop: 5,
        minWidth: 200,
        marginLeft: 20,
        margin: theme.spacing(1),
    },
}));

export const PopupRequiereAutorizacion = (props) => {
    const classes = useStyles();
    const { open, codNomAutor } = props;

    return (
        <Dialog
            fullWidth={true}
            open={open}
            className={classes.root}
            maxWidth="md"
        >
            <DialogTitle className={classes.header}>
                <Toolbar >
                    <Typography variant="h6" >
                        Prácticas que requieren autorización previa antes de asistir al turno
                    </Typography>
                </Toolbar>
            </DialogTitle>
            <div className={classes.rootTable}>
                <Grid item xs={12} md={12} style={{ marginTop: "2rem" }} >
                    <Card>
                        <TableGeneric
                            data={codNomAutor}
                            sizeTableCells={["8", "100%", "50%", "15%", "15%", "10%", "10%"]}
                            columns={[
                                {
                                    label: "Código Nomenclador",
                                    id: "cod_nom",
                                    sort: true
                                },
                                {
                                    label: "Descripcion",
                                    id: "des_Nom",
                                    sort: true
                            },
                            ]}
                        />
                    </Card>
                </Grid>
            </div>
            <DialogActions>
                <Button onClick={props.close} color="primary">
                   Confirmar
                </Button>
            </DialogActions>
        </Dialog>
    )
}
